import React from "react";
import cl from "classnames";
import { Subscribe } from "unstated";
import SrpContainer from "../../containers/SrpContainer";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import classes from "./styles.module.scss";

class Seo extends React.Component {
  state = {
    isShowingLongText: false,
  };

  readMore() {
    return this.setState({ isShowingLongText: !this.state.isShowingLongText });
  }

  render() {
    const { data, dynamicSearch = false } = this.props;
    const { isShowingLongText } = this.state;
    if (
      !data ||
      !data.seo ||
      !data.seo.title ||
      !data.place_model ||
      !data.place_model.name ||
      !data.all
    )
      return <div></div>;
    // console.log(data)
    return (
      <div className="seo">
        <Breadcrumbs />
        {!dynamicSearch && (
          <div className={classes.titles}>
            <h1
              className="h2 srp-seo-header"
              dangerouslySetInnerHTML={{ __html: data.seo.title }}
            ></h1>
            <h2>
              {data.all} venue{data.all === 1 ? "" : "s"}
            </h2>
          </div>
        )}
        {!dynamicSearch && data.seo.title && (
          <p
            className={cl("srp-seo-description", {
              "srp-seo-description--open": isShowingLongText,
            })}
            onClick={() => this.readMore()}
          >
            {data.seo.desc}
          </p>
        )}
      </div>
    );
  }
}

const SeoContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { data, dynamicSearch } }) => (
      <Seo data={data} dynamicSearch={dynamicSearch} />
    )}
  </Subscribe>
);

export default SeoContainer;
